import { AthenaEventSaveErrorReason } from "./AthenaEventSaveErrorReason.js";

type GenericAthenaEventSaveError<
  Reason extends AthenaEventSaveErrorReason,
  Retryable extends boolean,
> = {
  reason: Reason;
  retryable: Retryable;
  details: any;
};

export type UniqueViolationAthenaEventSaveError = GenericAthenaEventSaveError<
  AthenaEventSaveErrorReason.UniqueViolation,
  false
>;

export type ValidationAthenaEventSaveError = GenericAthenaEventSaveError<
  AthenaEventSaveErrorReason.Validation,
  false
>;

export type UnauthorizedAthenaEventSaveError = GenericAthenaEventSaveError<
  AthenaEventSaveErrorReason.Unauthorized,
  true
>;

export type AdditionAthenaEventSaveError = GenericAthenaEventSaveError<
  AthenaEventSaveErrorReason.Addition,
  false
>;

export type BackendUnreachableAthenaEventSaveError =
  GenericAthenaEventSaveError<
    AthenaEventSaveErrorReason.BackendUnreachable,
    true
  >;

export type UnknownAthenaEventSaveError = GenericAthenaEventSaveError<
  AthenaEventSaveErrorReason.Unknown,
  true
>;

export type AthenaEventSaveError =
  | UniqueViolationAthenaEventSaveError
  | ValidationAthenaEventSaveError
  | UnauthorizedAthenaEventSaveError
  | AdditionAthenaEventSaveError
  | BackendUnreachableAthenaEventSaveError
  | UnknownAthenaEventSaveError;

export function makeUniqueViolation(
  details: any,
): UniqueViolationAthenaEventSaveError {
  return {
    reason: AthenaEventSaveErrorReason.UniqueViolation,
    retryable: false,
    details: details,
  };
}

export function makeValidation(details: any): ValidationAthenaEventSaveError {
  return {
    reason: AthenaEventSaveErrorReason.Validation,
    retryable: false,
    details: details,
  };
}

export function makeUnauthorized(
  details: any,
): UnauthorizedAthenaEventSaveError {
  return {
    reason: AthenaEventSaveErrorReason.Unauthorized,
    retryable: true,
    details: details,
  };
}

export function makeAddition(details: any): AdditionAthenaEventSaveError {
  return {
    reason: AthenaEventSaveErrorReason.Addition,
    retryable: false,
    details: details,
  };
}

export function makeBackendUnreachable(
  details: any,
): BackendUnreachableAthenaEventSaveError {
  return {
    reason: AthenaEventSaveErrorReason.BackendUnreachable,
    retryable: true,
    details: details,
  };
}

export function makeUnknown(details: any): UnknownAthenaEventSaveError {
  return {
    reason: AthenaEventSaveErrorReason.Unknown,
    retryable: true,
    details: details,
  };
}
